export const BREEDS = [
  "골든두들", "골든리트리버", "그레이트덴", "그레이트피레니즈", "그레이하운드",
  "꼬똥드툴레아", "뉴펀들랜드", "닥스훈트", "달마시안", "도고아르젠티노",
  "도베르만", "라브라도 리트리버", "라사압소", "라이카", "로트와일러",
  "마리노이즈", "마스티프", "말티즈", "말티푸", "몰키", "미니핀",
  "바센지", "바셋하운드", "바이마리너", "버니즈마운틴독", "베들링턴 테리어",
  "보더콜리", "보스톤테리어", "복서", "볼조이", "불개", "불독",
  "불테리어", "브러쉘그리폰", "브리타니", "비글", "비숑프리제",
  "비어디드콜리", "비즐라", "빠삐용", "사모예드", "삽살이", "샤페이",
  "세인트버나드", "세퍼트", "셰틀랜드쉽독", "슈나우저", "스탠다드 푸들",
  "시바견", "시베리안허스키", "시츄", "아메리카코커스파니엘", "아이리쉬세타",
  "아키타", "아프간하운드", "알래스카 말라뮤트", "알래스칸 클리카이",
  "에어데일 테리어", "오브차카", "올드 잉글리쉬 쉽독", "와이어 폭스테리어",
  "요크셔테리어", "웰쉬코기 카디건", "이탈리안 그레이하운드", "잉글리쉬코카스파니엘",
  "잭 러셀 테리어", "저패니즈스피츠", "진돗개", "차우차우", "치와와",
  "친(chin)", "케인코르소", "콜리", "킹찰스스파니엘", "토이푸들",
  "퍼그", "페키니즈", "펨브록 웰시 코기", "포메라니안", "포인터",
  "폼스키", "폼피츠", "푸들", "풍산개", "프랜치불독", "핏불테리어", "화이트테리어"
];

export const REGIONS = [
  "전국", "서울시", "인천시", "경기도", "부산시", "대구시", "대전시", "광주시",
  "울산시", "강원도", "충청남도", "충청북도", "경상남도", "경상북도",
  "전라남도", "전라북도", "제주도", "세종시"
];

export const GENDERS = ["모두선택", "남아", "여아"];

export const PRICES = ["전체", "무료분양", "10만원 이하", "10-30만원", "30-50만원", "50-100만원", "100만원 이상"];
